import { defineMessages } from 'react-intl';

const attributeMessages = defineMessages({
    provider: {
        id: 'provider-attribute',
        defaultMessage: 'Provider',
    },
    model: {
        id: 'model-attribute',
        defaultMessage: 'Model',
    },
    name: {
        id: 'name-attribute',
        defaultMessage: 'Name',
    },
    OSS: {
        id: 'oss-attribute',
        defaultMessage: 'OSS',
    },
    ossName: {
        id: 'oss-name-attribute',
        defaultMessage: 'Name in OSS',
    },
    ossId: {
        id: 'oss-id-attribute',
        defaultMessage: 'OSS id',
    },
    undergroundConnection: {
        id: 'underground-connection-attribute',
        defaultMessage: 'Underground Connection',
    },
    container: {
        id: 'container-attribute',
        defaultMessage: 'Container',
    },
    type: {
        id: 'type-attribute',
        defaultMessage: 'Type',
    },
    start: {
        id: 'start-attribute',
        defaultMessage: 'Start',
    },
    end: {
        id: 'end-attribute',
        defaultMessage: 'End',
    },
    stage: {
        id: 'stage-attribute',
        defaultMessage: 'Stage',
    },
    stages: {
        id: 'documents-stages-attribute',
        defaultMessage: 'Stages',
    },
    download: {
        id: 'documents-download-attribute',
        defaultMessage: 'Download',
    },
    project: {
        id: 'project-attribute',
        defaultMessage: 'Project',
    },
    projectStage: {
        id: 'project-stage-attribute',
        defaultMessage: 'Stage',
    },
    buildingStatus: {
        id: 'project-building-status-attribute',
        defaultMessage: 'Building Status',
    },
    export: {
        id: 'export-attribute',
        defaultMessage: 'Export',
    },
    alias: {
        id: 'alias-attribute',
        defaultMessage: 'Alias',
    },
    ref: {
        id: 'code-attribute',
        defaultMessage: 'Code',
    },
    hasSot: {
        id: 'has-sot-attribute',
        defaultMessage: 'Has SOT',
    },
    shared: {
        id: 'is-shared-attribute',
        defaultMessage: 'Is shared',
    },
    providerRef: {
        id: 'provider-ref-attribute',
        defaultMessage: 'Provider Ref',
    },
    assetType: {
        id: 'asset-type',
        defaultMessage: 'Asset Type',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    level: {
        id: 'level-attribute',
        defaultMessage: 'Level',
    },
    overground: {
        id: 'overground-attribute',
        defaultMessage: 'Overground',
    },
    underground: {
        id: 'underground-attribute',
        defaultMessage: 'Underground',
    },
    height: {
        id: 'height-attribute',
        defaultMessage: 'Height',
    },
    attenuation: {
        id: 'attenuation-attribute',
        defaultMessage: 'Attenuation',
    },
    number: {
        id: 'number-attribute',
        defaultMessage: 'Number',
    },
    numberingScheme: {
        id: 'numbering-scheme-attribute',
        defaultMessage: 'Numbering Scheme',
    },
    uSlotNumber: {
        id: 'u-slot-number-attributes',
        defaultMessage: 'U Slot Number',
    },
    capabilities: {
        id: 'capabilities-attribute',
        defaultMessage: 'Capabilities',
    },
    capable100M: {
        id: 'capabilities-capable-100M',
        defaultMessage: '100M',
    },
    capable1G: {
        id: 'capabilities-capable-1G',
        defaultMessage: '1G',
    },
    capable10G: {
        id: 'capabilities-capable-10G',
        defaultMessage: '10G',
    },
    capable40G: {
        id: 'capabilities-capable-40G',
        defaultMessage: '40G',
    },
    noCapabilities: {
        id: 'empty-capabilities-label',
        defaultMessage: 'N/A',
    },
    coordinates: {
        id: 'coordinates-attribute',
        defaultMessage: 'Coordinates',
    },
    continuousPipe: {
        id: 'continuous-pipe-attribute',
        defaultMessage: 'Continuous pipe',
    },
    propertyOwner: {
        id: 'property-owner',
        defaultMessage: 'Property owner',
    },
    providerInfrastructure: {
        id: 'provider-infrastructure',
        defaultMessage: 'EMS WEB PRO infrastructure',
    },
    batteries: {
        id: 'batteries',
        defaultMessage: 'Batteries',
    },
});

export default attributeMessages;
